<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.categoryId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined" :hideOverlayRoute="$route.params.categoryId == undefined"
      @Added="handleadded" @Changed="handlechanged">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <ArticleSelect2 v-if="!hideArticleFilter" v-model="articlefilter" clearable multiple externaledit
              class="ma-3">
            </ArticleSelect2>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getJobCategoryListFromFilter" :lockedFilters="lockedFilters"
          :optional-filters="filters" :paginationEnabled="true" :show-filter-tab="true" :show-sorting-tab="false"
          :itemsPerPage="50" ref="ListPane" :dialog-trigger="dialogtrigger" :dialogItem="editItem"
          :dialog-method-config="dialogMethodConfig" :open-function="openItem" :pk="pk" @Added="onCreated">

          <template v-slot:list-item="{ item, handlechanged }">
            <ListItem :item="item" @click="openItem(item)" @change="handlechanged">
            </ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12">
                  <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.lead.lead_type_name')"
                    externaledit :rules="[requiredRule]">
                  </QTextField>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>
    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import ArticleSelect2 from "@/components/Inputs/EntityDropdowns/ArticleSelect2.vue";
import ListItem from "@/components/ListItems/JobCategoryListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminJobCategoryList",
  props: {
    hideArticleFilter: Boolean,
    lockedFilters: Object,
  },
  components: {
    FilterPane,
    ListPane,
    Layout,
    ListItem,
    DefaultLifeCycleFilterGroup,
    ArticleSelect2,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "JCL-",
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createJobCategory',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeJobCategory',
        },
      },
    };
  },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "JobCategories") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewJobCategory', params: { categoryId: item.Id }, query })
    },

    onCreated(item) {
      this.openItem(item);
    },

    handleadded(item) { this.$refs.ListPane.handleadded(item); },

    handlechanged(item) { this.$refs.ListPane.handlechanged(item); },

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          ArticleNumberList: this.articlefilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    articlefilter: {
      get() { return this.getQueryParam("filter-articles", []); },
      set(update) { this.setQueryParam("filter-articles", update); },
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); },
  },
};
</script>